import React, { FC } from 'react';
import { LuAlertTriangle } from 'react-icons/lu';
import { Text } from '@/components';

interface FieldErrorProps {
  message?: string;
}

/**
 * Shared inline field-error display used by ConfigInput and ConfigDropdown.
 * Shows a red pill-style banner with an icon + message.
 */
const FieldError: FC<FieldErrorProps> = ({ message }) => {
  return (
    <div className="h-4">
      <Text
        as="p"
        size="xs"
        weight="normal"
        color="danger"
        className={`flex items-center gap-1 transition-opacity duration-150 ${message ? 'opacity-100' : 'opacity-0 pointer-events-none select-none'}`}
      >
        <LuAlertTriangle className="w-2.5 h-2.5 flex-shrink-0" />
        {message}
      </Text>
    </div>
  );
};

export default FieldError;
